import script from "./SetupForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SetupForm.vue?vue&type=script&setup=true&lang=js"

import "./SetupForm.vue?vue&type=style&index=0&id=4e7795bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e7795bc"]])

export default __exports__